module.exports = __webpack_public_path__ + "static/media/Futura_ICG.279af718.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Futura_ICG.ttf
// module id = 728
// module chunks = 0